export const siteContent = {
  contact: {
    phone: "7273252595",
    email: "humans@buildsuncoast.com",
    phoneHref: "tel:7273252595",
    emailHref:
      "mailto:humans@buildsuncoast.com?subject=Suncoast%20Homes%20Inquiry",
  },
  logo: {
    url: "https://customer-assets.emergentagent.com/job_34172cd5-f985-406e-9730-402f3cb49788/artifacts/jbwbpilp_Suncoast%20Homes.png",
    alt: "Suncoast Homes logo",
  },
  heroImage:
    "https://static.prod-images.emergentagent.com/jobs/34172cd5-f985-406e-9730-402f3cb49788/images/6f06f3ec12219f86a20680ed3006f3c6b9e6273b4f54d1db0225f22b3b888892.png",
  legacyImage:
    "https://customer-assets.emergentagent.com/job_34172cd5-f985-406e-9730-402f3cb49788/artifacts/tzo325t3_206%20Frierson.webp",
  hero: {
    overline: "Pinellas County, Florida",
    title: "Coastal luxury. Heritage craftsmanship.",
    subtitle:
      "In-house design, engineering, and construction for refined coastal homes.",
  },
  turnkeyHighlights: [
    "Turnkey service",
    "Your plan or ours",
    "Your lot or ours",
    "Financing gladly arranged",
  ],
  pillars: [
    {
      title: "A family legacy",
      description:
        "From historic Tampa homes to modern coastal builds, the work is grounded in craftsmanship that lasts.",
    },
    {
      title: "Beach-focused expertise",
      description:
        "Today the focus is Pinellas County’s shoreline communities and coastal living done well.",
    },
    {
      title: "Design with presence",
      description:
        "Clean lines, resilient materials, and curb appeal with restraint.",
    },
  ],
  processSteps: [
    {
      phase: "01",
      title: "Design",
      description:
        "We shape the vision and coordinate the path from the start.",
      details: ["Vision", "Selections"],
    },
    {
      phase: "02",
      title: "Engineering",
      description:
        "Engineering stays in house so the process stays clear and build-ready.",
      details: ["Plans", "Coordination"],
    },
    {
      phase: "03",
      title: "Construction",
      description:
        "Specialist team members guide each step with craftsmanship and schedule discipline.",
      details: ["Specialist team", "Turnkey delivery"],
    },
  ],
  stats: [
    { label: "Generations", value: "3" },
    { label: "Core market", value: "Pinellas Beaches" },
    { label: "Approach", value: "Mid-luxury custom" },
  ],
  featuredProjects: [
    {
      name: "Brochure Top Rendering",
      location: "Coastal exterior concept",
      image:
        "https://customer-assets.emergentagent.com/job_beach-homes-pinellas/artifacts/hmu6gvnf_Brochure%20Top%20Pic.jpg",
      span: "md:col-span-8 md:row-span-2",
    },
    {
      name: "Brochure Top Pic 2",
      location: "Beach house rendering",
      image:
        "https://customer-assets.emergentagent.com/job_beach-homes-pinellas/artifacts/vwjjpu3y_Brochure%20Top%20Pic%202.jpg",
      span: "md:col-span-4",
    },
    {
      name: "Rear Rendering",
      location: "Outdoor living view",
      image:
        "https://customer-assets.emergentagent.com/job_beach-homes-pinellas/artifacts/1iukgod4_Brochure%20Top%20Pic%20rear.jpg",
      span: "md:col-span-4",
    },
    {
      name: "Concept Floor Plan 01",
      location: "Open-source reference",
      image:
        "https://images.unsplash.com/photo-1721244654195-943615c56ac4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGZsb29yJTIwcGxhbiUyMGJsdWVwcmludHxlbnwwfHx8fDE3NzU5OTk0MzZ8MA&ixlib=rb-4.1.0&q=85",
      span: "md:col-span-4",
    },
    {
      name: "Concept Floor Plan 02",
      location: "Open-source reference",
      image:
        "https://images.unsplash.com/photo-1721244654210-a505a99661e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxob3VzZSUyMGZsb29yJTIwcGxhbiUyMGJsdWVwcmludHxlbnwwfHx8fDE3NzU5OTk0MzZ8MA&ixlib=rb-4.1.0&q=85",
      span: "md:col-span-8",
    },
  ],
  serviceAreas: [
    "St. Pete Beach",
    "Treasure Island",
    "Indian Rocks Beach",
    "Clearwater Beach",
    "Belleair Shore",
    "South Tampa",
  ],
  coastlineAreas: [
    "Clearwater Beach",
    "Sand Key",
    "Belleair Beach",
    "Indian Rocks Beach",
    "Indian Shores",
    "Redington Shores",
    "North Redington Beach",
    "Redington Beach",
    "Madeira Beach",
    "Treasure Island",
    "Sunset Beach",
    "St. Pete Beach",
    "Pass-a-Grille",
    "Boca Ciega Bay",
  ],
  coastalNeighborhoods: [
    {
      title: "Clearwater Beach to Sand Key",
      summary:
        "Visible hospitality energy, high-demand waterfront positioning, and buyers looking for polished coastal presence.",
      image:
        "https://customer-assets.emergentagent.com/job_beach-homes-pinellas/artifacts/74ktsygx_Front%20Elev%20Rendering.jpg",
    },
    {
      title: "Belleair Beach to Indian Rocks Beach",
      summary:
        "A layered mix of older beach cottages, long-held family properties, and high-end luxury replacements.",
      image:
        "https://customer-assets.emergentagent.com/job_beach-homes-pinellas/artifacts/1t3f900k_1417%20E%20Frierson%201920.png",
    },
    {
      title: "Indian Shores through the Redington Beaches",
      summary:
        "Hospitality and short-term rental thinking meet compact lots, feasibility study discipline, and strong pro forma planning.",
      image:
        "https://customer-assets.emergentagent.com/job_beach-homes-pinellas/artifacts/23rl585x_202%20Rampart%20New%20Build%20REO.webp",
    },
    {
      title: "Madeira Beach to Boca Ciega Bay",
      summary:
        "Single-family luxury, rooftop entertainment, and bay-to-beach outdoor living with elevated finish expectations.",
      image:
        "https://customer-assets.emergentagent.com/job_beach-homes-pinellas/artifacts/8wjxv9me_3906%20Swann%20Ave%20New%20Construction.webp",
    },
  ],
  marketServices: [
    {
      title: "Turnkey in-house delivery",
      description:
        "Design, engineering, and construction are handled in house.",
    },
    {
      title: "Beach-market planning",
      description:
        "STR feasibility, pro formas, and single-family planning are shaped around each beach market.",
    },
    {
      title: "Elevated living details",
      description:
        "Rooftop entertaining, outdoor living, chef kitchens, and custom storage tailored to each home.",
    },
  ],
  investorTeaser: {
    title: "Investor-minded opportunities.",
    description:
      "Florida beach real estate can offer exceptional returns. Suncoast Homes brings local knowledge, network strength, and turnkey delivery.",
  },
  investorPage: {
    title: "Turnkey investor opportunities in Florida beach real estate.",
    subtitle:
      "Suncoast Homes supports investor-minded projects with feasibility study thinking, pro forma discipline, local market knowledge, and an in-house path from design through construction.",
    pillars: [
      {
        title: "Your plan or ours",
        description: "Start with your concept or let Suncoast Homes shape the direction in-house.",
      },
      {
        title: "Your lot or ours",
        description: "Move forward with a site you already control or discuss the right opportunities along the beach corridor.",
      },
      {
        title: "Financing gladly arranged",
        description: "Financing support can be coordinated as part of a more complete, turnkey conversation.",
      },
    ],
    cards: [
      {
        title: "Feasibility study",
        description: "Early-stage analysis aligned to product type, market fit, and the realities of the beach submarket.",
      },
      {
        title: "Project pro forma",
        description: "Clearer investment framing before design and construction decisions lock in cost and scope.",
      },
      {
        title: "Local knowledge & network",
        description: "Beach rental and investor-minded opportunities benefit from local connections, practical knowledge, and aligned execution from the start.",
      },
    ],
  },
  testimonial: {
    quote: "we are so lucky to have Jesse as our builder",
    author: "Kelsey",
    location: "IRB",
    project: "Coastal Build",
  },
};